<template>
	<div class="compressOver-bac open-compressOver">
		<div class="compressOver-main">
			<div class="compressOver-main-box">
				<div class="compressOver-img">
					<img :src="imgSrc" alt="" />
				</div>
				<div class="compressOver-content">
					<p>{{ $t("compressioncomplete") }}</p>
					<p>{{ $t("click") }}"{{ $t("openvip") }}",{{ $t("compressionisnolongerlimit") }}</p>
				</div>
				<div class="compressOver-VIP" @click="toVIP">
					<span>{{ $t("openvip") }}</span>
				</div>
			</div>
			<div class="compressOver-main-close" @click="closecompressOver()"></div>
		</div>
	</div>
</template>
<script>
import ShopVue from "../dialogs/Shop";
import LoginVue from "./Login.vue";
export default {
	name: "compressOverMain",
	data() {
		return {
			routetype: "",
			size: "",
			imgSrc: null,
		};
	},
	watch: {},
	methods: {
		toVIP() {
			gevt(
				"压缩结束弹窗_开通VIP",
				"点击事件",
				`${this.routetype}压缩`,
				"None",
				this.$app.VIPState,
				"None"
			);
			//没登陆用户+非VIP用户
			if (this.$app.isLogin) {
				//登陆成功，判断是否是VIP
				if (!this.$app.VIPlevel) {
					//非VIP打开收银台
					this.$dlg.show(ShopVue).then((res) => {
						this.closecompressOver();
					});
				} else {
					this.closecompressOver();
				}
			} else {
				this.$dlg.show(LoginVue).then((res) => {
					if (this.$app.isLogin) this.toVIP();
					else this.closecompressOver();
				});
			}
		},
		closecompressOver(flag) {
			this.$emit("close", flag);
		},
	},
	mounted() {
		if (this.$route.path == "/main/tpys") {
			this.routetype = "图片";
			this.size = "200k";
			this.imgSrc = require("../../mycomponents/img/main-limit/pic_tupian_vip@2x.png");
		} else if (this.$route.path == "/main/spys") {
			this.routetype = "视频";
			this.imgSrc = require("../../mycomponents/img/main-limit/pic_video_vip@2x.png");
		} else if (this.$route.path == "/main/wordys") {
			this.routetype = "Word";
			this.imgSrc = require("../../mycomponents/img/main-limit/pic_WORD_vip@2x.png");
		} else if (this.$route.path == "/main/pptys") {
			this.routetype = "PPT";
			this.imgSrc = require("../../mycomponents/img/main-limit/pic_PPT_vip@2x.png");
		} else if (this.$route.path == "/main/pdfys") {
			this.routetype = "PDF";
			this.imgSrc = require("../../mycomponents/img/main-limit/pic_pdf_vip@2x.png");
		}
		// console.log("大小限制弹窗monted");
		gevt("压缩结束弹窗", "视图事件", `${this.routetype}压缩`, "None", this.$app.VIPState, "None");
	},
};
</script>

<style lang="less">
.compressOver-bac {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 9998;
	background: rgba(0, 0, 0, 0.4);
	/* display: flex; */
	display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.compressOver-main {
	height: 275rem;
	width: 360rem;
	position: absolute;
	z-index: 9999;
	/* display: none; */
	background: white;
	border-radius: 8rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.compressOver-main-box {
	width: 100%;
	height: 108%;
	/* border: 1rem solid black; */
}
.compressOver-img {
	/* border: 1rem solid black; */
	margin: 41rem auto 20rem;
	width: 28.47%;
	height: 28.63%;
}
.compressOver-img img {
	width: 100%;
}
.compressOver-content {
	width: 80%;
	margin: 0rem auto;
	/* padding: 15rem 0 0 0; */
	text-align: center;
	font-size: 14rem;
	line-height: 23rem;
	color: #7889ab;
	p {
		&:nth-of-type(1) {
			margin-bottom: 8rem;
		}
	}
}
.compressOver-VIP {
	width: 55.56%;
	height: 35rem;
	margin: 20rem auto 32rem;
	background: linear-gradient(44deg, #f6da65 0%, #ffc43e 100%);
	opacity: 1;
	text-align: center;
	border-radius: 15rem;
	margin-bottom: 23rem;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
}
.compressOver-VIP:hover {
	background: #f7d688d7;
}
.compressOver-VIP span {
	display: inline-block;
	padding: 0 0 2rem 0;
	vertical-align: middle;
	font-size: 16rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 19rem; */
	color: #3e2e09;
	opacity: 1;
}
.compressOver-close {
	position: absolute;
	top: 5rem;
	right: 5rem;
}
.compressOver-main-close {
	position: absolute;
	right: 12rem;
	top: 0;
	width: 24rem;
	height: 40rem;
	background-image: url("../../mycomponents/img/main-limit/icon_syt_gb01@2x.png");
	background-size: cover;
	cursor: pointer;
}

/* js */
.open-compressOver {
	display: flex !important;
}
</style>
